export class Page<T> {

    constructor(public elements:T[],public page:number,public size:number,public totalElements:number){

    }

}